import { getApiConfig } from '../utils/apiUtils';
import axios from 'axios';

const API_BASE = '/distribution/api/inventories';

export const fetchAllInventories = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.room_type_id) params.append('room_type_id', filters.room_type_id);
  
  const url = params.toString() ? `${API_BASE}/?${params.toString()}` : `${API_BASE}/`;
  const response = await axios.get(url, getApiConfig());
  return response.data;
};

export const fetchInventoryById = async (inventoryId) => {
  const response = await axios.get(`${API_BASE}/${inventoryId}/`, getApiConfig());
  return response.data;
};

export const createInventory = async (inventoryData) => {
  const response = await axios.post(`${API_BASE}/`, inventoryData, getApiConfig());
  return response.data;
};

export const deleteInventory = async (inventoryId) => {
  const response = await axios.delete(`${API_BASE}/${inventoryId}/`, getApiConfig());
  return response.data;
};

